import React from 'react';
import { useGlobalStore } from 'stores/global';

const ProductHit = ({ hit }) => {
  const { setShowSearch } = useGlobalStore((state) => state);
  return (
    <div key={hit.id} className="default-hover">
      <img src={hit?.defaultImage?.url || `/404.svg`} alt={hit.name} />
      <a
        tabIndex={0}
        href={hit.custom_url.url}
        onClick={() => setShowSearch(false)}
        className="block-content"
      >
        <p>{hit.name}</p>
        <p className="line-clamp-2">
          <strong>${hit.calculated_price?.toFixed(2)}</strong>
        </p>
      </a>
    </div>
  );
};

export default ProductHit;
